const nextAlphaNumericIndex = (text, startIndex) => {
  let nextIndex = startIndex;

  while (nextIndex < text.length && /[^a-zA-Z0-9]/.test(text[nextIndex])) {
    nextIndex += 1;
  }

  return nextIndex;
};

export const getHighlightRange = (text, highlight) => {
  const start = text
    .toLowerCase()
    .indexOf(highlight.substring(0, 2).toLowerCase());

  if (start < 0) {
    return {start, end: undefined};
  }

  let end = start;
  for (const char of highlight) {
    if (!char) {
      continue;
    }

    end = nextAlphaNumericIndex(text, end);
    end += 1;

    if (end >= text.length) {
      break;
    }
  }

  return {start, end};
};
